import React, { useContext, useEffect, useState } from 'react';
import styles from './PreAuthenticationDetails.module.scss';
import { useNavigate } from 'react-router-dom';
import BackArrow from '../../../assets/backArrow.svg';
import MenuItemsPageContext, { IMenuItemContext } from '../../Contexts/MenuItemsPageContext/MenuItemsPageContext';
import { useTranslation } from '../../hooks/useTranslation';

interface IProps {
	storeId: string;
	tableName: string;
	showInfo : boolean;
	isPayWithCard: boolean;
}

const PreAuthHeader: React.FC<IProps> = (props) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { storeId, tableName, showInfo, isPayWithCard } = props;
	const tableRefId = localStorage.getItem('tableRef');
	const { merchantData } = useContext(MenuItemsPageContext) as IMenuItemContext;
	const [merchantName, setMerchantName] = useState<string>('');

	useEffect(() => {
		if (!merchantData) {
			const shopName = localStorage.getItem('merchantName');
			if (shopName) {
				setMerchantName(shopName);
			}
		} else {
			localStorage.setItem('merchantName', merchantData.name);
			setMerchantName(merchantData.name);
			if (merchantData.logoUrl) {
				localStorage.setItem('merchantLogo', merchantData.logoUrl);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleBackClick = () => {
		localStorage.removeItem('customerEmail');
		navigate(`/${storeId}?tableRef=${tableRefId}`);
	};

	return (
				<section id="preAuthHeaderContainer" className={`${styles.preAuthHeaderContainer} Container`}>
					<section className={`${styles.preAuthHeaderSubContainer} `}>
						<div className="six column row">
							<div className={styles.top_headerdiv}>
								<button className={styles.backArrow} onClick={handleBackClick}>
									<img src={BackArrow} className={styles.backButton} alt={t('component:image:back:alt')} />
								</button>
								<h3>{t('page:preAuthHeader:addCard:heading')}</h3>
							</div>
							<div className={styles.restaurant_div}>
							<div className={styles.dividerContainer}></div>
							<h3 className={styles.restaurantName}>{merchantName}</h3>
							<div className={styles.table_area}>
								<p className={styles.tableText}>
									{t('page:preAuthDetail:table:label')}
								</p>
								<p className={styles.tableText}> {tableName}</p>
							</div>
							</div>
							<div className={styles.dividerContainer}></div>
							{ !showInfo && <div className={styles.headinginfo}>{isPayWithCard ? t('page:preAuthDetail:enterInfo:heading') : t('page:preAuthDetail:choosePaymentMethod:heading')}</div> }
						</div>
					</section>
				</section>
	);
};

export default PreAuthHeader;
